var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83317 3.83334H3.99984C2.71117 3.83334 1.6665 4.87801 1.6665 6.16667V19C1.6665 20.2887 2.71117 21.3333 3.99984 21.3333H16.8332C18.1218 21.3333 19.1665 20.2887 19.1665 19V13.1667M17.5166 2.18342C18.4278 1.27219 19.9052 1.27219 20.8164 2.18342C21.7276 3.09464 21.7276 4.57203 20.8164 5.48325L10.7997 15.5H7.49984L7.49984 12.2002L17.5166 2.18342Z",
    stroke: "#111827",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.88b8aed3ae663212a7272d6ec40d43d5.svg";
export { ForwardRef as ReactComponent };